import React, { useState, useEffect, useRef } from 'react';
import {  useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const CODE_LENGTH = new Array(6).fill(0);

const PhoneCodeInput = ({value, onChange, onSubmit}) => {

    const inputRef = useRef()
    //const [value, setValue] = useState('')
    const [focus, setFocus] = useState(false)
    const theme = useTheme()
    const ismobile = useMediaQuery(theme.breakpoints.down('sm')) 
    const values = value.split('')

    const classes = useStyles()

    useEffect(() => {
        if(inputRef.current) inputRef.current.focus() 
    }, [])

    const handleClick = () => {
        inputRef.current.focus()
    }
    const handleFocus = () => {
        setFocus(true)
    }
    const handleBlur = () => {
        setFocus(false)
    }

    const handleChange = (e) => {
        const _value = e.target.value
        if(isNaN(parseInt(_value))) return

        if(value.length >= CODE_LENGTH.length) return 
        let temp = (value + _value).slice(0, CODE_LENGTH.length)
        onChange(temp)
    }

    const handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            let temp = value.slice(0, value.length - 1)
            onChange(temp)
        }else{
            if(value.length === CODE_LENGTH.length){
                console.log('Disparar submit')
                onSubmit()
            }
        }
        
      };

    const selectedIndex = values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;

    return ( 
        <div className={classes.wrap} onClick={handleClick}>
            <input
                value=""
                type='tel'
                ref={inputRef}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handleChange}
                onKeyUp={handleKeyUp}
                className={classes.input}
                style={{ width: !ismobile ? "54px" : '40px', top: "0px", bottom: "0px", left: `${selectedIndex * (!ismobile ? 60 : 48)}px`}}
            />
            {CODE_LENGTH.map((item, key)=>{

                const selected = values.length === key;
                const filled =
                  values.length === CODE_LENGTH.length && key === CODE_LENGTH.length - 1;

                return <div className={classes.display} key={`input-cont-${key}`}>
                        {values[key]}
                        {(selected || filled) && focus && <div className={classes.shadows}/>}
                    </div>
            })}
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    wrap:{
        //border: '1px solid rgba(0, 0, 0, 0.2)',
        //display: 'inline-block',
        position: 'relative',
        display: 'flex',
    },
    display:{
        border: '1px solid rgba(0, 0, 0, 0.2)',
        width: 54,
        height: 58,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 32,
        position: 'relative',
        margin:'0px 4px ',
        //borderRadius:4,
        borderRadius:12,
        [theme.breakpoints.down('sm')]:{
            width: 40,
        }
        
    }, 
    input:{
        position: 'absolute',
        border: 'none',
        fontSize: 32,
        textAlign: 'center',
        backgroundColor: 'transparent',
        outline: 'none',
        zIndex:1
    },
    shadows:{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        boxShadow: '0 0 0 4px rgba(58, 151, 212, 0.28)',
    }
    
    
}))
 
export default PhoneCodeInput;
 